export let app = {
    debug: false
}

export const setApp = (a) => {
    app = a
}